import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useLang } from "@/lib/i18n";

export default function AboutPage() {
    const [s, setS] = useState({});
    const { t, lang } = useLang();
    useEffect(() => { document.title = `${t("about")} | ${t("siteName")}`; api.get("/public/settings").then((r) => setS(r.data || {})); }, [t]);
    const text = t("aboutText");
    return (
        <div className="mx-auto max-w-3xl px-4 py-16">
            <div className="mb-6 border-b border-gray-200 pb-4 flex items-center gap-3">
                <div className="h-10 w-1.5 rounded-sm bg-brand-red" />
                <h1 className="font-display font-black text-3xl md:text-4xl text-brand-black">{t("about")}</h1>
            </div>
            <p className="prose-ar text-lg leading-loose" dir={lang !== "ar" ? "ltr" : "rtl"} data-testid="about-text">{text}</p>
            {lang === "ar" && s.tagline && <p className="mt-6 text-lg text-brand-red font-display font-bold">{s.tagline}</p>}
        </div>
    );
}
